import { render } from "./UploadFilesPopUp.vue?vue&type=template&id=3350c31e&scoped=true&ts=true"
import script from "./UploadFilesPopUp.vue?vue&type=script&lang=ts"
export * from "./UploadFilesPopUp.vue?vue&type=script&lang=ts"

import "./UploadFilesPopUp.vue?vue&type=style&index=0&id=3350c31e&scoped=true&lang=sass"

import exportComponent from "/home/casedrive/releases/front/108/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3350c31e"]])

export default __exports__